import { Component, OnInit } from '@angular/core';

import { GlobalServices } from '../../shared/services/global.services';

@Component({
  selector: 'app-maintenance',
  templateUrl: './maintenance.component.html',
  styleUrls: ['./maintenance.component.scss']
})
export class MaintenanceComponent implements OnInit {

  constructor(private globalService: GlobalServices) { }

  ngOnInit(): void {
    this.globalService.headerData$.next({
      headerTitle: 'Maintenance',
      showBackButton: false
    });
  }

}
